module.exports = __webpack_public_path__ + "img/lender_benefit_hero.4fe0ad66.jpg";